// extracted by mini-css-extract-plugin
export default {"float-subtext":"range-summary_float-subtext__X0j4W"};